module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-12.4883e266.jpg";